"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarPicker = CalendarPicker;
var _react = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireDefault(require("react-datepicker"));
var _core = require("@material-ui/core");
var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));
var _DateTime = require("../utils/DateTime");
require("react-frontend-utils/dist/styles.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * Customization of the React-DatePicker component, that removes the actual text field (replaces with a CalendarIcon). Implementer is 
 * in charge of displaying the selected date however they want.  The Calendar header has been customized to show dropdown menus 
 * for Month and Year, with advance and back buttons for Months.
 * 
 * The following props should be passed:
 * 
 * disabled {Boolean}  true to disable the component
 * maxYear {Integer} the maximum year to show, if null, today's year is used
 * initialDate {Date}   the initial selected date, if null, today's date is used
 * dateChanged {Function}  a callback function that takes a Date parameter, when the date is selected from the calendar
 *
 * 
 * Optional props:
 * minYear {Integer} the minimum year to show, if null, 1900 is used
 * label {String} a title at the top of the calendar, if not provided, no title is shown
 * icon {React Component} an icon for the calendar, if not provided, the default calendar icon is shown
 * 
 */

function CalendarPicker(props) {
  var iconStyle = props.style;
  var calColor = props.calendarColor ? props.calendarColor : 'black';
  var calIcon = props.icon ? props.icon : /*#__PURE__*/_react["default"].createElement(_Today["default"], {
    style: {
      fontSize: 28,
      color: props.disabled ? 'lightGray' : calColor
    }
  });
  var CalendarIcon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      ref: ref,
      edge: "end",
      disabled: props.disabled,
      onClick: props.onClick,
      style: iconStyle
    }, calIcon);
  });
  var years = _DateTime.DateUtils.yearsArray(props.maxYear, props.minYear);
  var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var CustomHeader = function CustomHeader(_ref) {
    var date = _ref.date,
      changeYear = _ref.changeYear,
      changeMonth = _ref.changeMonth,
      decreaseMonth = _ref.decreaseMonth,
      increaseMonth = _ref.increaseMonth,
      prevMonthButtonDisabled = _ref.prevMonthButtonDisabled,
      nextMonthButtonDisabled = _ref.nextMonthButtonDisabled;
    return /*#__PURE__*/_react["default"].createElement("div", null, props.label ? /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        fontSize: 14,
        fontWeight: 600,
        textAlign: 'center'
      }
    }, props.label) : null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        margin: 10,
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/_react["default"].createElement("select", {
      value: date.getFullYear(),
      onChange: function onChange(_ref2) {
        var value = _ref2.target.value;
        return changeYear(value);
      },
      style: {
        marginRight: 10
      }
    }, years.map(function (option) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: option,
        value: option
      }, option);
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        margin: 10,
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      onClick: decreaseMonth,
      disabled: prevMonthButtonDisabled,
      style: {
        marginRight: 10
      }
    }, "<"), /*#__PURE__*/_react["default"].createElement("select", {
      value: months[date.getMonth()],
      onChange: function onChange(_ref3) {
        var value = _ref3.target.value;
        return changeMonth(months.indexOf(value));
      },
      style: {
        marginRight: 10
      }
    }, months.map(function (option) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: option,
        value: option
      }, option);
    })), /*#__PURE__*/_react["default"].createElement("button", {
      onClick: increaseMonth,
      disabled: nextMonthButtonDisabled
    }, ">")));
  };
  var selectDateCallback = function selectDateCallback(date) {
    var dateWithoutTime = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    props.dateChanged(dateWithoutTime);
  };
  return /*#__PURE__*/_react["default"].createElement(_reactDatepicker["default"], {
    showMonthDropdown: true,
    showYearDropdown: true,
    disabled: props.disabled ? props.disabled : false,
    renderCustomHeader: CustomHeader,
    dropdownMode: "select",
    selected: props.initialDate,
    popperPlacement: "top",
    onChange: selectDateCallback,
    customInput: /*#__PURE__*/_react["default"].createElement(CalendarIcon, null)
  });
}
;